export const D25 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Product Sales by Customer Group (PESO)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Customer Group',
                        "columnName": 'CustomerGroup',
                        "width": '300px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales(Value)',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'LYSales',
                        "columnName": 'LYSales(Value)',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth(Value)',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "percent": true
                    }
                ],
                "title": 'CustomerGroup',
                "endpoint": "D25",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "DistrictManagerCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": 'CustomerGroup',
                        "visuals": [
                            // {
                            //   "title": "Region",
                            //   "visual": [
                            //     {
                            //       "columns": 12,
                            //       "rows": 2,
                            //       "visual": {
                            //         "id": 1,
                            //         "type": "advancedTable",
                            //         "colorTheme": "colorTheme1",
                            //         "title": "Region",
                            //         "binding": {
                            //           "data": {
                            //             "columns": [
                            //               {
                            //                 "name": 'Region',
                            //                 "columnName": 'RegionCode',
                            //                 "width": '150px',
                            //                 "align": "left",
                            //                 "sortable": true,
                            //                 "sum": false
                            //               },
                            //               {
                            //                 "name": 'Actual Sales',
                            //                 "columnName": 'ActualSales(Value)',
                            //                 "width": '140px',
                            //                 "align": "right",
                            //                 "sortable": true,
                            //                 "sum": true
                            //               },
                            //               {
                            //                 "name": 'LYSales',
                            //                 "columnName": 'LYSales(Value)',
                            //                 "width": '150px',
                            //                 "align": "right",
                            //                 "sortable": true,
                            //                 "sum": true
                            //               },
                            //               {
                            //                 "name": 'Growth %',
                            //                 "columnName": 'Growth(Value)',
                            //                 "width": '150px',
                            //                 "align": "right",
                            //                 "sortable": true,
                            //                 "percent": true
                            //               }
                            //             ],
                            //             "title": 'RegionCode',
                            //             "endpoint": "D25.1",
                            //             "parameters": [
                            //               { "key": "FromMonth", "value": "2024" },
                            //               { "key": "FromYear", "value": "1" },
                            //               { "key": "ToMonth", "value": "2024" },
                            //               { "key": "ToYear", "value": "1" },
                            //               { "key": "DistrictManagerCode", "value": "" },
                            //               { "key": "CustomerGroup", "value": "" },
                            //               { "key": "ConfigTypeCode", "value": "" }
                            //             ]
                            //           },
                            //           "context": {
                            //             "point": {
                            //               "onClick": {

                            //               }
                            //             }
                            //           }
                            //         }
                            //       }
                            //     }
                            //   ]
                            // },
                            {
                                "title": "District",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "District",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'District',
                                                            "columnName": 'DistrictName',
                                                            "width": '150px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LYSales',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'DistrictName',
                                                    "endpoint": "D25.3",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "DistrictManagerCode", "value": "" },
                                                        { "key": "CustomerGroup", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "CustomerGroupDistrictName",
                                                            "selectedTitle": "Product",
                                                            "visual": [
                                                                {
                                                                    "columns": 12,
                                                                    "rows": 2,
                                                                    "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": "colorTheme1",
                                                                        "title": "Product",
                                                                        "binding": {
                                                                            "data": {
                                                                                "columns": [
                                                                                    {
                                                                                        "name": 'Item Name',
                                                                                        "columnName": 'ItemName',
                                                                                        "width": '200px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (PESO)',
                                                                                        "columnName": 'ActualSales(Value)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (PESO)',
                                                                                        "columnName": 'LYSales(Value)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (PESO)',
                                                                                        "columnName": 'Growth(Value)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (UNIT)',
                                                                                        "columnName": 'ActualSales(Qty)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (UNIT)',
                                                                                        "columnName": 'LYSales(Qty)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (UNIT)',
                                                                                        "columnName": 'Growth(Qty)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    }
                                                                                ],
                                                                                "title": "ItemName",
                                                                                "endpoint": "D25.4",
                                                                                "parameters": [
                                                                                    { "key": "FromMonth", "value": "" },
                                                                                    { "key": "FromYear", "value": "" },
                                                                                    { "key": "ToMonth", "value": "" },
                                                                                    { "key": "ToYear", "value": "" },
                                                                                    { "key": "DistrictManagerCode", "value": "" },
                                                                                    { "key": "CustomerGroupDistrictName", "value": "" },
                                                                                    { "key": "ConfigTypeCode", "value": "" }
                                                                                ]
                                                                            },
                                                                            "context": {
                                                                                "point": {
                                                                                    "onClick": {

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                "title": "PMR",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "PMR",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'PMR Code',
                                                            "columnName": 'AgentCode',
                                                            "width": '150px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Employee Code',
                                                            "columnName": 'EmployeeCode',
                                                            "width": '160px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'PMR Name',
                                                            "columnName": 'AgentName',
                                                            "width": '150px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LYSales',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'AgentName',
                                                    "endpoint": "D25.2",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "DistrictManagerCode", "value": "" },
                                                        { "key": "CustomerGroup", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "CustomerGroupAgentNameEmployeeCode",
                                                            "selectedTitle": "Product",
                                                            "visual": [
                                                                {
                                                                    "columns": 12,
                                                                    "rows": 2,
                                                                    "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": "colorTheme1",
                                                                        "title": "Product",
                                                                        "binding": {
                                                                            "data": {
                                                                                "columns": [
                                                                                    {
                                                                                        "name": 'Item Name',
                                                                                        "columnName": 'ItemName',
                                                                                        "width": '200px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (PESO)',
                                                                                        "columnName": 'ActualSales(Value)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (PESO)',
                                                                                        "columnName": 'LYSales(Value)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (PESO)',
                                                                                        "columnName": 'Growth(Value)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'Sales (UNIT)',
                                                                                        "columnName": 'ActualSales(Qty)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LYSales (UNIT)',
                                                                                        "columnName": 'LYSales(Qty)',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": '% Growth (UNIT)',
                                                                                        "columnName": 'Growth(Qty)',
                                                                                        "width": '170px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    }
                                                                                ],
                                                                                "title": "ItemName",
                                                                                "endpoint": "D25.5",
                                                                                "parameters": [
                                                                                    { "key": "FromMonth", "value": "" },
                                                                                    { "key": "FromYear", "value": "" },
                                                                                    { "key": "ToMonth", "value": "" },
                                                                                    { "key": "ToYear", "value": "" },
                                                                                    { "key": "DistrictManagerCode", "value": "" },
                                                                                    { "key": "CustomerGroupAgentNameEmployeeCode", "value": "" },
                                                                                    { "key": "ConfigTypeCode", "value": "" }
                                                                                ]
                                                                            },
                                                                            "context": {
                                                                                "point": {
                                                                                    "onClick": {

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }
            }
        }
    }
}